<template>
  <InputCurrency
    :disabled="!menuPermissionsStore.canWriteSubComponents"
    ref="priceSelect"
    v-model="value"
    noUndefinedValue
  />
</template>

<script setup lang="ts">
import { nextTick, ref, watch } from 'vue';
import { useMenuPermissionsStore } from '@centric-os/stores/auth/use-menu-permissions-store';

const menuPermissionsStore = useMenuPermissionsStore();

const value = defineModel({ type: Number, required: true });

const priceSelect = ref(null);

watch(priceSelect, async (newVal) => {
  if (newVal) {
    await nextTick();
    priceSelect.value.inputRef.select();
  }
});
</script>
